import { createActions } from 'redux-actions';
import { Order } from '@models/Order';
import { HealthClaim } from '@models/HealthClaim';
import { GetOrderParams } from '@apis/OrderApi';
import { CreateHealthClaimParams } from '@apis/HealthClaimApi';

export type State = {
  policy: Order | null | undefined;
  healthClaim: HealthClaim | null | undefined;
};
export type StateUpdatePayload = Partial<State>;
export type PolicyFetchPayload = GetOrderParams;
export type HealthClaimCreatePayload = CreateHealthClaimParams;

export const {
  policyFetch,
  healthClaimCreate,

  stateUpdate,
} = createActions(
  'POLICY_FETCH',
  'HEALTH_CLAIM_CREATE',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_POLICY_CLAIM_HEALTH_POLICY_CLAIM',
  },
);
